import { render, staticRenderFns } from "./MonederosRestauranteForm.vue?vue&type=template&id=7d70c58a"
import script from "./MonederosRestauranteForm.vue?vue&type=script&lang=js"
export * from "./MonederosRestauranteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports